module.exports = __webpack_public_path__ + "img/img6_5.bf3142a6.jpeg";